import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const USER_ENDPOINTS = {
  list: `${BASE_URL}api/users/`,
  register: `${BASE_URL}auth/register`,
  me: `${BASE_URL}users/me`,
  detail: (id) => `${BASE_URL}users/${id}`,
  roles: `${BASE_URL}api/roles/`,
  export_members: `${BASE_URL}api/users/export_members`
};

class Users {
  async getUsers(query){
    const { data } = await request({
      url: USER_ENDPOINTS.list,
      query
    });
    return data;
  }

  async getActiveUserInfo() {
    const { data } = await request({
      url: USER_ENDPOINTS.me,
    });
    return data;
  }

  async getUser(id) {
    const { data } = await request({
      url: USER_ENDPOINTS.detail(id),
    });
    return data;
  }

  async deleteUser(id) {
    await request({
      url: USER_ENDPOINTS.detail(id),
      method: "DELETE",
    });
  }

  async editOrCreateUser(id = null, payload = {}) {
    const isEdit = id && id !== 'create';
    return await request({
      url: isEdit ? USER_ENDPOINTS.detail(id) : USER_ENDPOINTS.register,
      method: isEdit ? "PATCH" : "POST",
      body: payload,
    });
  }

  async getRoles() {
    const { data } = await request({
      url: USER_ENDPOINTS.roles,
    });
    return data;
  }
}

export const UsersService = new Users();
